import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    StagesetActivateDraft as StagesetActivateDraftMutation,
    StagesetActivateDraftVariables,
    StagesetActivateDraftInput,
} from 'nutshell-graphql-types';

import STAGESET_ACTIVATE_DRAFT from '../mutations/stageset-activate-draft.graphql';
import GET_STAGESETS from '../queries/get-stagesets-for-pipeline-list.graphql';

export const useStagesetActivateDraft = (): {
    stagesetActivateDraft: (arg1: StagesetActivateDraftInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [stagesetActivateDraft, {loading, error}] = useMutation<
        StagesetActivateDraftMutation,
        StagesetActivateDraftVariables
    >(STAGESET_ACTIVATE_DRAFT);

    return {
        stagesetActivateDraft: (input: StagesetActivateDraftInput) =>
            stagesetActivateDraft({variables: {input}, refetchQueries: [{query: GET_STAGESETS}]}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
